import React from 'react';
import { mechanismVars } from '../data/content';
export function MechanismSection() {
  return <section className="w-full bg-verde py-14 text-white sm:py-16 lg:py-20" aria-labelledby="mecanismo" data-id="element-101" data-mp="hc6up45tyeup">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-102" data-mp="ccvcdqptf1b0">
        <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-103" data-mp="cfgd2cednb76">
          El mecanismo
        </p>
        <h2 id="mecanismo" className="mt-3 font-display text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-104" data-mp="152kde42iz1cm">
          Sistema de arbitraje de consumo
        </h2>
        <p className="mt-4 max-w-2xl text-lg leading-relaxed text-white/80" data-id="element-105" data-mp="vb6k4e162xrx">
          Suena técnico, pero es simple: antes de comprar, cruzás seis datos que casi todos miran
          sueltos. Cuando los mirás juntos, la decisión cambia.
        </p>

        <ol className="mt-10 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-106" data-mp="1j23mp072oiqi">
          {mechanismVars.map((v, i) => <li key={v.label} className="flex flex-col rounded-xl bg-verde-dark p-5 ring-1 ring-white/10" data-id="element-107" data-mp="7ppb7i7g8vsg" data-mpi={i}>
              <span className="font-mono text-xs text-white/50" data-id="element-108" data-mp="cr4x1chgb6bw">0{i + 1}</span>
              <span className="mt-1 font-display text-xl font-bold leading-tight" data-id="element-109" data-mp="3u50mqu5o6grb">{v.label}</span>
              <span className="mt-auto pt-3 text-sm leading-snug text-white/70" data-id="element-110" data-mp="2xo3m9l87t8r">{v.question}</span>
            </li>)}
        </ol>

        <div className="mt-6 rounded-xl bg-white p-6 text-ink sm:p-7" data-id="element-111" data-mp="3q3yke4gghol4">
          <p className="font-display text-lg font-bold leading-snug sm:text-xl" data-id="element-112" data-mp="3q59pq8pjv4ec">
            Los seis juntos te dan una sola respuesta: el precio final real de esa compra, hoy, para
            vos.
          </p>
          <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-113" data-mp="3g7ltfecapou2">
            No hay trucos, ni letra chica, ni nada raro. Son promociones y beneficios legítimos que
            ya están disponibles y que la mayoría desaprovecha simplemente por falta de organización.
          </p>
        </div>
      </div>
    </section>;
}